module.exports = __webpack_public_path__ + "static/cover-8107de13db53d7a037eca2ba154a5d70.png";